import { render, staticRenderFns } from "./PsiFormCheckboxField.vue?vue&type=template&id=725d1c88&scoped=true&"
import script from "./PsiFormCheckboxField.vue?vue&type=script&lang=js&"
export * from "./PsiFormCheckboxField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725d1c88",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('725d1c88')) {
      api.createRecord('725d1c88', component.options)
    } else {
      api.reload('725d1c88', component.options)
    }
    module.hot.accept("./PsiFormCheckboxField.vue?vue&type=template&id=725d1c88&scoped=true&", function () {
      api.rerender('725d1c88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/src/components/forms/PsiFormCheckboxField.vue"
export default component.exports